import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { Container } from '@atlassian/jira-common-directory-v2/src/components/text-cell/styled';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl
import { injectIntlV2 as injectIntl, useIntl } from '@atlassian/jira-intl';
import type { Props } from './types';
import { getTranslations } from './utils';

const Type = ({ simplified, intl: { formatMessage: formatMessageOld }, typeKey }: Props) => {
	const { formatMessage: formatMessageNew } = useIntl();

	const formatMessage = ff('hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3')
		? formatMessageNew
		: formatMessageOld;

	const getTypeName = (): string => {
		const translations = getTranslations(simplified);
		if (typeKey) {
			const translation = translations[typeKey];
			return translation ? formatMessage(translation) : '';
		}
		return '';
	};

	return typeKey ? (
		<StyledContainer>
			<TypeNameContainer>{getTypeName()}</TypeNameContainer>
		</StyledContainer>
	) : null;
};

// eslint-disable-next-line jira/js/no-inject-intl-if-functional-component
export default injectIntl(Type);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const TypeNameContainer = styled2.div({
	width: '100%',
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContainerOld = styled(Container)({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const StyledContainerNew = styled2(Container)({
	display: 'flex',
	alignItems: 'center',
});

const StyledContainer = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	StyledContainerNew,
	StyledContainerOld,
);
